<template>
  <!-- eslint-disable vue/no-v-html -->
  <div>
    <!-- <p id="test" hidden :v-html="noteContent"></p> -->
    <loading v-show="loading" :width="100" position="unset" />
    <div v-if="!loading">
      <b-tabs active-nav-item-class="nav nav-tabs" content-class="mt-3">
        <b-tab title="Notes" active>
          <VueEditor v-model="noteContent" :editor-toolbar="customToolbar" />
          <div class="align-right">
            <div
              v-show="addingNote"
              class="spinner spinner-primary spinner-sm"
            ></div>
            <b-button
              v-show="!addingNote"
              variant="primary m-1 ripple btn-sm add-note-btn"
              @click="addNote"
              >Add note</b-button
            >
          </div>
          <vue-perfect-scrollbar>
            <div class="chat-sidebar-container">
              <div class="chat-content-wrap">
                <div class="chat-content">
                  <div
                    v-for="note in notes"
                    :key="note.id"
                    class="d-flex mb-10 user"
                  >
                    <ProjectAvatar
                      image-url="@/assets/images/avatars/matthewt.svg"
                      :hide-nick-name="true"
                      :width="35"
                      :user="note.user"
                      class="m-r-10"
                    />
                    <div class="message flex-grow-1">
                      <div class="d-flex">
                        <p class="mb-1 text-title text-16 flex-grow-1">
                          {{ getUserName(note.user) }}
                        </p>
                        <span class="text-small text-muted">{{
                          note.date | moment("from")
                        }}</span>
                      </div>
                      <div
                        class="m-0 note-description"
                        v-html="note.content"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </vue-perfect-scrollbar>
        </b-tab>
        <b-tab title="Uploads">
          <b-row>
            <b-col :md="uploads.length > 0 ? 6 : 12">
              <b-form-file
                :id="`task_${task.id}_file`"
                v-model="document"
                type="file"
                placeholder="Choose or drop a document here"
                drop-placeholder="Drop document here"
                variant="primary"
                value="Upload"
                @input="uploadFile"
              >
                <template slot="file-name" slot-scope="{ names }">
                  <b-badge variant="dark">{{ names[0] }}</b-badge>
                  <b-badge v-if="names.length > 1" variant="dark" class="ml-1">
                    + {{ names.length - 1 }} More files
                  </b-badge>
                </template>
              </b-form-file>
              <div
                v-show="uploadingDoc"
                class="spinner spinner-primary spinner-sm"
              ></div>
            </b-col>
            <b-col v-show="uploads.length > 0" md="6">
              <b-card>
                <div
                  v-for="upload in uploads"
                  :key="upload.id"
                  class="upload-item"
                >
                  <a
                    :href="`${fileApiLink}?fileId=${upload.id}`"
                    target="_blank"
                    >{{ upload.name }}</a
                  >
                  <!-- <a @click.prevent="downloadFile(upload.id)">{{
                    upload.name
                  }}</a> -->
                  <p>{{ upload.date | moment("from") }}</p>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="History">
          <vue-perfect-scrollbar>
            <div class="chat-sidebar-container">
              <div class="chat-content-wrap">
                <div class="chat-content">
                  <div
                    v-for="item in history"
                    :key="item.id"
                    class="d-flex mb-10 user"
                  >
                    <ProjectAvatar
                      image-url="@/assets/images/avatars/matthewt.svg"
                      :hide-nick-name="true"
                      :width="35"
                      :user="item.user"
                      class="m-r-10"
                    />
                    <div class="message flex-grow-1">
                      <div class="d-flex">
                        <p class="mb-1 text-title text-16 flex-grow-1">
                          {{ getUserName(item.user) }}
                        </p>
                        <span class="text-small text-muted">{{
                          item.date | moment("from")
                        }}</span>
                      </div>
                      <div
                        class="m-0 note-description"
                        v-html="item.change"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </vue-perfect-scrollbar>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex"
import { VueEditor } from "vue2-editor"
import ProjectAvatar from "@/components/projectAvatar"
// import download from "download"
export default {
  components: {
    VueEditor,
    ProjectAvatar
  },
  props: {
    task: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: true,
      document: null,
      noteContent: "",
      addingNote: false,
      uploadingDoc: false,
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["code-block"]
      ],
      project: "",
      listName: ""
    }
  },
  computed: {
    ...mapState({
      users: state => state.users.all,
      taskextras: state => state.taskextras.all
    }),
    ...mapGetters({
      getCurrentUser: "getCurrentUser"
    }),
    fileApiLink() {
      return process.env.VUE_APP_FILE_HTTPS
    },
    notes() {
      return this.lodash.orderBy(this.task.notes, "date", "desc")
    },
    history() {
      return this.lodash.orderBy(this.task.history, "date", "desc")
    },
    uploads() {
      return this.task.files ?? []
    }
  },
  mounted() {
    this.loading = false
  },
  created() {
    this.listName = this.$parent.$parent.listName
    // this.project = this.$parent.$parent.$parent.$parent.$parent.$parent.project
  },
  methods: {
    async downloadFile() {
      // await download(`${process.env.FILE_HTTPS}?fileId=${id}`)
    },
    /**
     *
     * @param user
     * @returns {string}
     */
    getUserName(user) {
      return user
        ? `${user.firstName} ${user.lastName}`
        : "[User no longer exists]"
    },
    async uploadFile() {
      // await this.$utils.mutateWithFile(
      //   `mutation addFile($task: TaskInput!){
      //   addFile(task:$task)
      //   }`,
      //   this.document,
      //   {
      //     task: { id: this.task.id, sectionId: this.task.sectionId }
      //   }
      // )
      const fileId = await this.$utils.uploadTaskFile(
        this.document,
        this.task.id
      )
      if (fileId) {
        this.task.files.push({
          name: this.document.name,
          id: fileId
        })

        this.document = null
      }
    },
    /**
     *
     * @returns {Promise<ToastObject>}
     */
    async addNote() {
      if (this.noteContent.length === 0 || !this.noteContent.trim()) {
        return this.$toasted.error("You'll need to enter some content first...")
      }
      this.addingNote = true
      this.task.notes.push({
        date: new Date(),
        user: this.getCurrentUser,
        content: this.noteContent
      })
      //add to db
      await this.$apollo.mutate({
        mutation: require("@/graphql/Note/AddNote.gql"),
        variables: {
          note: {
            taskId: this.task.id,
            userId: this.getCurrentUser.id,
            content: this.noteContent
          }
        }
      })
      this.addingNote = false
      this.noteContent = ""
    }
  }
}
</script>
<style scoped>
.spinner {
  margin: 4px;
}
.chat-sidebar-container {
  max-height: 300px;
}
.text-title {
  line-height: normal;
}
.note-description {
  font-size: 12px;
}
.message {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
.add-note-btn {
  margin-top: 9px !important;
  margin-right: 0px !important;
}
.upload-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.upload-item p {
  margin-bottom: 0px;
  font-size: 10px;
}
</style>
